import { render, staticRenderFns } from "./AdminSport.vue?vue&type=template&id=a39deb12&"
import script from "./AdminSport.vue?vue&type=script&lang=js&"
export * from "./AdminSport.vue?vue&type=script&lang=js&"
import style0 from "./AdminSport.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports